import { render, staticRenderFns } from "./TemplateViewPdfIframe.vue?vue&type=template&id=558854e9&scoped=true&"
import script from "./TemplateViewPdfIframe.vue?vue&type=script&lang=ts&"
export * from "./TemplateViewPdfIframe.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateViewPdfIframe.vue?vue&type=style&index=0&id=558854e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558854e9",
  null
  
)

export default component.exports